(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[624],{

/***/ "htfC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Trident3", function() { return Trident3; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Trident3 = function Trident3(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 513 342.5"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M513 277.3l-39.1-39.6-39 39.6 39 39.8 39.1-39.8zM467.1 10.1c-2.3-8.5-20.9 3.8-61.1 40.2 16 17.9 24 7.7 37 2.9 10.2 19.9 14.2 109.2-52.9 136.2 1.7-90 2.6-186.3 2.6-186.3l-4-3.1c-18.4 2.5-51.2 35.4-76.4 63.2 13.8 23.1 31.6 2.3 45.5-3.4 0 3.8-3.2 70.2-1.8 137.8-69.1 5.2-58-137.7-54-156 1.6-14.7-44.5 17.8-67.4 39.4 7.1 13.2 17.3 10.5 30 5.7-4.7 64.2 39.8 122.5 91.5 121 2 66.1 8.6 130.3 27.5 134.8 2.7.6 4.7-67 6.2-142.1 124.7-39.3 77.3-190.3 77.3-190.3zm-232.3 97c0 29-16.1 51.1-48.3 66.5 16.2 5.6 29.5 14.3 39.9 25.9 10.3 11.7 15.5 25.8 15.5 42.3 0 28.4-10.6 50.7-31.9 67.1-21.3 16.4-51.4 24.6-90.4 24.6-31.9 0-58.4-7.2-79.6-21.7-21.1-14.4-34-35.5-38.8-63.3h61.2c5.9 28.1 25 42.1 57.2 42.1 18.9 0 33.9-4.1 45-12.4 11.1-8.3 16.6-20.2 16.6-35.9 0-14.2-5.5-25.1-16.4-32.8-10.9-7.7-25-11.5-42.1-11.5H86.8v-46.1h31.5c18.3 0 32.2-4 41.7-12s14.2-18.5 14.2-31.5c0-12.4-4.4-22.2-13.3-29.2-8.9-7.1-22.3-10.6-40.3-10.6-13.6 0-25.2 3.8-34.8 11.5-9.6 7.7-15.4 18.2-17.5 31.5H7.5c3.8-26 15.7-46.8 35.5-62.5 19.8-15.7 45.6-23.5 77.6-23.5 36.9 0 65.2 7.4 84.9 22.2 19.5 14.7 29.3 34.5 29.3 59.3z"
  }));
};

/***/ })

}]);